import React from 'react';
import '../styles/Footer.scss';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const appVersion = process.env.REACT_APP_VERSION || '1.0.0';

  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <div className="footer-left">
          <span className="footer-status">
            {/* <span className="footer-status-dot" />
            Connected */}
          </span>
        </div>
        <div className="footer-center">
          <span className="footer-copyright">
            &copy; {currentYear} Alaska Airlines. All rights reserved.
          </span>
        </div>
        <div className="footer-right">
          {/* <span className="footer-version">v{appVersion}</span> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
